/**
 * Determines the appropriate indefinite article ("a" or "an") for a given word
 * based on whether the first letter is a vowel.
 *
 * @param {string} word - The word needing an indefinite article
 * @returns {string} The appropriate indefinite article ("a" or "an")
 */
export const getGrammarArticle = (word: string): string => {
  if (!word) return 'a';
  const firstLetter = word.trim().toLowerCase().charAt(0);
  return ['a', 'e', 'i', 'o', 'u'].includes(firstLetter) ? 'an' : 'a';
};

export default getGrammarArticle;
